/**
 * Local calendar days (each at local midnight) from `start`'s day through
 * `end`, inclusive.
 * @param {Date} start
 * @param {Date} end
 * @returns {Date[]}
 */
export function eachLocalDay(start, end) {
  const days = [];
  const day = new Date(start);
  day.setHours(0, 0, 0, 0);
  while (day.getTime() <= end.getTime()) {
    days.push(new Date(day));
    day.setDate(day.getDate() + 1);
  }
  return days;
}
